import React, { useEffect, useState } from "react";
import { siteRoutes } from "../../../utils/helpers/enums/routes";
import { useNavigate } from "react-router-dom";
import useStore from "hooks/useStore";
import useAmbassador from "../useHooks";
import { warningToaster } from "../../../utils/helpers/common/alert-service";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";
import EventDetailModal from "./component";
import CustomMessageDisplay from "components/data-not-found/CustomMessageDisplay";
import noFoundGif from "assets/images/gifs/noFoundGif.gif";
import { useSelector } from "react-redux";

const AmbassadorWelcome = () => {
  const { getAdminAmbassadorEvents } = useAmbassador();
  const { getAmbassadorprofileType } = useStore();
  const { isLoading } = useSelector((state: any) => state.sharedReducer);

  const [data, setData] = useState<any>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState<any>(null);
  const [hasFetched, setHasFetched] = useState(false);
  const ambassadorprofileType = getAmbassadorprofileType();
  const mappedEventType =
    !ambassadorprofileType ||
    ambassadorprofileType === "leader" ||
    ambassadorprofileType === "null"
      ? "WELCOME"
      : ambassadorprofileType === "builder"
      ? "TRAINING"
      : "WELCOME";

  const getAllEvents = async () => {
    await getAdminAmbassadorEvents(setData, {
      page: 0,
      size: 3,
      future: true,
      eventType: mappedEventType,
    });
    setHasFetched(true);
  };

  useEffect(() => {
    getAllEvents();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  console.log(data, "dataaaa");

  const handleEventClick = (event: any) => {
    setSelectedEvent(event);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedEvent(null);
  };

  // Helper function to format date
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "short" });
    return { day, month };
  };

  // Helper function to format time
  const formatTime = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  return (
    <div className="container min-h-screen">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-6">
        {data.map((exp: any) => {
          if (!exp || !exp.start || !exp.end) return null;
          
          const { day, month } = formatDate(exp.start);
          const startTime = formatTime(exp.start);
          const endTime = formatTime(exp.end);
          const imageUrl =
            exp.media && exp.media.length > 0
              ? concatPathWithBackendUrl(exp.media[0].name)
              : "";

          return (
            <div
              key={exp.id}
              className="p-3 bg-white rounded-xl border border-borderColor cursor-pointer hover:shadow-lg transition-shadow duration-200"
              onClick={() => handleEventClick(exp)}
            >
              <div className="relative">
                <img
                  src={imageUrl}
                  alt={exp.name || "Event"}
                  className="w-full h-32 object-cover rounded-xl"
                />
                <div className="absolute top-2 left-2 bg-white text-center p-2 rounded-md">
                  <span className="block text-sm font-bold text-primaryBlueText">
                    {day}
                  </span>
                  <span className="block text-xs text-primaryBlueText">
                    {month}
                  </span>
                </div>
              </div>
              <div className="py-2">
                <h3 className="text-lg capitalize font-semibold text-blackie">
                  {exp.name || "Untitled Event"}
                </h3>
                {/* Time Display */}
                <div className="mt-2">
                  <div className="flex flex-wrap items-center justify-between text-sm">
                    <div className="flex items-center gap-2">
                      <span className="text-gray-600">Start:</span>
                      <span className="font-medium text-gray-800">
                        {startTime}
                      </span>
                    </div>
                    <div className="flex items-center gap-2">
                      <span className="text-gray-600">End:</span>
                      <span className="font-medium text-gray-800">
                        {endTime}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <CustomMessageDisplay
        show={hasFetched && !isLoading && data.length === 0}
        title={`No ${mappedEventType} Events Available`}
        slogan={`There are no ${mappedEventType.toLowerCase()} events scheduled at this time.`}
        image={noFoundGif}
        imageAlt="No events found"
        className="py-12"
        imageClassName="w-24 h-24"
        titleClassName="text-2xl font-bold text-blackie"
        sloganClassName="text-gray-500 text-base"
      />

      {/* Event Detail Modal */}
      <EventDetailModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        eventData={selectedEvent}
      />
    </div>
  );
};

export default AmbassadorWelcome;
